<template>
    <div >
      <el-checkbox
        v-if="permission.level != 1"
        :indeterminate="permission.isIndeterminate"
        v-model="permission.checkAll"
        @change="handleCheckAllChange"
      >{{ permission.name }} </el-checkbox>
  
      <div :class="floatClass(permission)" v-if="permission.children && permission.children.length  > 0" style="margin-left: 40px; " >
		<permission-item  
          v-for="child in permission.children"
          :key="child.id"
          :permission="child"
          @update:select="handleSelect"
        ></permission-item>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PermissionItem',
    props: {
      permission: Object,
    },
    methods: {
		floatClass(permission) {
		  if (permission.level === 3) return 'sel_float';
		  if (permission.level === 2) {
		    const hasLevel3 = Array.isArray(permission.children)
		      ? permission.children.some(c => c.level === 3)
		      : false;
		    return hasLevel3 ? 'sel_clear' : 'sel_float';
		  }
		  return 'sel_clear';
		},
      handleCheckAllChange(value) {
        this.$set(this.permission, 'checkAll', value);   // ✅ 自身写回用 $set
        this.updateChildrenCheckState(this.permission, value);
        this.updateParentCheckState(this.permission);    // 父状态统一重算
      },
      handleSelect(data) {
        this.updateParentCheckState(data.permission);
      },
      updateChildrenCheckState(permission, value) {
        if (permission.children) {
          permission.children.forEach(child => {
            this.$set(child, 'checkAll', value);
            this.updateChildrenCheckState(child, value);
          });
        }
      },
      updateParentCheckState(node) {
        if (!node || !node.parent) return;
        const parent = node.parent;
        const children = Array.isArray(parent.children) ? parent.children : [];
        const total = children.length;
      
        if (total === 0) {
          this.$set(parent, 'isIndeterminate', false);
        } else {
          const checked = children.filter(c => !!c.checkAll).length;
          const indet = children.some(c => !!c.isIndeterminate);
      
          const allChecked = checked === total;
          const noneChecked = checked === 0 && !indet;
      
          // ✅ 直接覆盖父的 checkAll，而不是“只在全/全不选时改”
          this.$set(parent, 'checkAll', allChecked);
          this.$set(parent, 'isIndeterminate', !allChecked && !noneChecked);
        }
        this.updateParentCheckState(parent);
      }

    },
    watch: {
      'permission.children': {
        handler() {
          this.updateParentCheckState(this.permission); // 仅根据子项变化重算父状态
        },
        deep: true
      }
    }

  }
  </script>
  <style>
	  .sel_clear>div{
		  clear: both; 
	  }
	  .sel_float>div{
		  
		  float: left;
		  margin-right: 20px;
	  }
  </style>
  